export const copyToClipboard = (input) => {
  navigator.clipboard.writeText(input);
};